import { Animation } from './Animation/Animation';
import { ElementRef } from '@angular/core';
import { IActor } from "app/Actor/IActor";

export abstract class ActorBase {
 
    public name: string;
    public img_id: ElementRef;
    public animations: Array<Animation>;
    public p_x: number;
    public p_y: number;
    public vel_x: number;
    public vel_y: number; 
    public w: number; 
    public h: number; 
    public scaleW: number;
    public scaleH: number;
    public state: number;  
    public deleted: boolean;
    public exploted: boolean;

    
    
}




// WEBPACK FOOTER //
// D:/xamppabeel/htdocs/Angular2Projects/CanvasSVG/src/app/Actor/ActorBase.ts